import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button, InputGroup, Card, Modal, Table } from 'react-bootstrap';
import Select from 'react-select';
import { Search } from 'react-bootstrap-icons';
import APIserver from '../../../../api/axiosConfig';

// Función para convertir fecha ISO a formato YYYY-MM-DD
const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    d.setMinutes(d.getMinutes() + d.getTimezoneOffset()); // Ajuste de zona horaria
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

// Función para convertir fecha en formato YYYY-MM-DD a fecha ISO
const parseDate = (date) => {
    if (!date) return '';
    return new Date(`${date}T00:00:00`).toISOString(); // Forzar la hora a medianoche en local
};

function EditarClienteFactura({ factura, setFactura, setformaPago, setdondePago, setnumGuia, settransportadora, setProductos}) {
    const [showModal, setShowModal] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [clienteInput, setClienteInput] = useState(factura.nombreCliente || '');
    const [formaPago, setformaPagoState] = useState('');
    const [dondePago, setDondePagoState] = useState('');
    const [numGuia, setNumGuiaState] = useState('');
    const [transport, settransportadoraState] = useState('');


    useEffect(() => {
        setClienteInput(factura.nombreCliente || '');
    }, [factura.nombreCliente]);

    const optionsPedido = [
        { value: 'efectivo', label: 'Efectivo' },
        { value: 'banco', label: 'Banco' },
        { value: 'contraentrega', label: 'Contraentrega' }

    ];
    const optionsTranspotadora = [
        { value: 'interrapidisimo', label: 'Interrapidisimo' },
        { value: 'envia', label: 'Envia' },
        { value: 'domicilio', label: 'Domicilio' },
        { value: 'servientrega', label: 'Servientrega' },
        { value: 'otros', label: 'Otros' }

    ];

    const optionsTipoFactura = [
        { value: 'distribucion', label: 'Distribución' },
        { value: 'unidad', label: 'Unidad' }
    ];
    useEffect(() => {
        if (factura) {
            setformaPagoState(factura.formaPago || '');
            setDondePagoState(factura.dondePago || '');
            setNumGuiaState(factura.numGuia || '');
            settransportadoraState(factura.transport || '');
        }
    }, [factura]);

    // Función para buscar clientes por nombre
    const searchClientes = async (nombre) => {
        if (nombre.trim() === '') {
            setSearchResults([]);
            return;
        }
        try {
            const response = await APIserver.get(`/api/nombre/buscar?nombre=${nombre}`);
            setSearchResults(response.data);
        } catch (error) {
            console.error('Error al buscar clientes:', error);
        }
    };

    // Función para buscar cliente por clienteID
    const searchClienteById = async (clienteID) => {
        if (!clienteID) return;
        try {
            const response = await APIserver.get(`/api/buscarClientes/${clienteID}`);
            const cliente = response.data;

            if (cliente) {
                setFactura(prevFactura => ({
                    ...prevFactura,
                    idCliente: cliente.idCliente,
                    clienteID: cliente.clienteID,
                    nombreCliente: cliente.nomCliente
                }));
                setClienteInput(cliente.nomCliente);  // Actualiza el nombre del cliente
            }
        } catch (error) {
            console.error('Error al buscar cliente por ID:', error);
        }
    };

    // Función que maneja la búsqueda al presionar Enter en el campo clienteID
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            searchClienteById(e.target.value);  // Llama a la función si se presiona Enter
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFactura(prevFactura => ({
            ...prevFactura,
            [name]: name.includes('fecha') ? parseDate(value) : value
        }));
    };

    const handleSearchClick = () => {
        searchClientes(clienteInput);
        setShowModal(true);
    };

    const handleSelectCliente = (cliente) => {
        setFactura(prevFactura => ({
            ...prevFactura,
            idCliente: cliente.idCliente,
            clienteID: cliente.clienteID,
            nombreCliente: cliente.nomCliente
        }));
        setClienteInput(cliente.nomCliente);
        setShowModal(false);
    };
    const handleDondePagoChange = (e) => {
        const value = e.target.value;
        setDondePagoState(value);
        setdondePago(value); // Actualiza el estado en el componente padre
    };

    const handleNumGuiaChange = (e) => {
        const value = e.target.value;
        setNumGuiaState(value);
        setnumGuia(value); // Actualiza el estado en el componente padre
    };

    const handleformaPagoChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        setformaPagoState(selectedValue);
        setformaPago(selectedValue);
    };
    const handletransportadoraChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        settransportadoraState(selectedValue);
        settransportadora(selectedValue);
    };
    const handleSelectChange = (selectedOption, { name }) => {
        console.log('Selected option:', selectedOption);
        console.log('Field name:', name);
        setFactura(prevFactura => {
            const updatedFactura = {
                ...prevFactura,
                [name]: selectedOption ? selectedOption.value : ''
            };
    
            if (name === 'tipoFactura') {
                console.log('Changing tipoFactura to:', selectedOption.value);
                setProductos(prevProductos => prevProductos.map(producto => ({
                    ...producto,
                    valorUnitario: selectedOption.value === 'distribucion' ? producto.precioM : producto.precioU
                })));
            }
    
            return updatedFactura;
        });
    };
    return (
        <>
            <Card className='shadow-none'>
                <Card.Header className='fw-bold'>Detalles Cliente</Card.Header>
                <Card.Body>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className='mt-0' controlId='clienteID'>
                                    <Form.Label className='w-100'>Identificación
                                        <Form.Control
                                            type='number'
                                            name='clienteID'
                                            value={factura.clienteID || ''}
                                            onChange={handleChange}
                                            onKeyPress={handleKeyPress} // Añadir el evento para capturar la tecla Enter
                                            className='mt-2'
                                        />
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group className='mt-2' controlId='fechaVencimiento'>
                                    <Form.Label className='w-100'>Vence
                                        <Form.Control
                                            type='date'
                                            name='fechaVencimiento'
                                            className='mt-2'
                                            value={formatDate(factura.fechaVencimiento)}
                                            onChange={handleChange}
                                        />
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group className='mt-2' controlId='formaPago'>
                                    <Form.Label className='w-100'>Forma de Pago
                                        <Select
                                            placeholder='Forma de Pago'
                                            name='formaPago'
                                            className='mt-2'
                                            options={optionsPedido}
                                            value={optionsPedido.find(option => option.value === formaPago)}
                                            onChange={handleformaPagoChange}
                                            required
                                        />
                                    </Form.Label>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mt-0" controlId="nomCliente">
                                    <Form.Label>Cliente</Form.Label>
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            type='text'
                                            name='nombreCliente'
                                            value={clienteInput}
                                            onChange={(e) => {
                                                setClienteInput(e.target.value);
                                                handleChange(e);
                                                searchClientes(e.target.value);
                                            }}
                                        />
                                        <Button variant='outline-dark' title='Buscar cliente' onClick={handleSearchClick}>
                                            <Search />
                                        </Button>
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group className='mt-2' controlId='formaPago'>
                                    <Form.Label className='w-100'>Transportadora
                                        <Select
                                            placeholder='transportadora'
                                            name='transport'
                                            className='mt-2'
                                            options={optionsTranspotadora}
                                            value={optionsTranspotadora.find(option => option.value === transport)}
                                            onChange={handletransportadoraChange}
                                            required
                                        />
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group className='mt-2' controlId='numGuia'>
                                    <Form.Label className='w-100'>Numero de Guia
                                        <Form.Control
                                            type='text'
                                            name='numGuia'
                                            placeholder='numGuia'
                                            className='mt-2'
                                            value={numGuia}
                                            onChange={handleNumGuiaChange}
                                            required
                                        />
                                    </Form.Label>
                                </Form.Group>
                            </Col>
                            <Col>


                                <Form.Group className='mt-0' controlId='fechaCreacion'>
                                    <Form.Label className='w-100'>Elaboración
                                        <Form.Control
                                            type='date'
                                            name='fechaCreacion'
                                            className='mt-2'
                                            value={formatDate(factura.fechaCreacion)}
                                            onChange={handleChange}
                                        />
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group className='mt-2' controlId='nomSucursal'>
                                    <Form.Label className='w-100'>¿En donde pago?
                                        <Form.Control
                                            type='text'
                                            name='dondePago'
                                            placeholder='¿En donde pago?'
                                            className='mt-2'
                                            value={dondePago}
                                            onChange={handleDondePagoChange}
                                            required
                                        />
                                    </Form.Label>

                                </Form.Group>

                                <Form.Group className='mt-2' controlId='tipoFactura'>
                                    <Form.Label className='w-100'>Tipo
                                        <Select
                                            name='tipoFactura'
                                            className='mt-2'
                                            value={optionsTipoFactura.find(option => option.value === factura.tipoFactura)}
                                            options={optionsTipoFactura}
                                            onChange={(option) => handleSelectChange(option, { name: 'tipoFactura' })}
                                        />
                                    </Form.Label>
                                </Form.Group>

                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>

            {/* Modal de búsqueda de clientes */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Seleccionar Cliente</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InputGroup className="mb-3">
                        <Form.Control
                            type='text'
                            placeholder='Buscar cliente por nombre, cedula o numero'
                            value={clienteInput}
                            onChange={(e) => {
                                setClienteInput(e.target.value);
                                searchClientes(e.target.value);
                            }}
                        />
                    </InputGroup>
                    <Table responsive className='shadow-none text-center mt-3'>
                        <thead className='bg-primary-subtle'>
                            <tr>
                                <th>Identificación</th>
                                <th>Nombre</th>
                                <th>Numero</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {searchResults.length === 0 ? (
                                <tr>
                                    <td colSpan="3">Cliente no encontrado</td>
                                </tr>
                            ) : (
                                searchResults.map(cliente => (
                                    <tr key={cliente.idCliente}>
                                        <td>{cliente.clienteID}</td>
                                        <td>{cliente.nomCliente}</td>
                                        <td>{cliente.numCliente}</td>

                                        <td>
                                            <Button variant='outline-success' size='sm' onClick={() => handleSelectCliente(cliente)}>
                                                Seleccionar
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default EditarClienteFactura;
